module.exports = "/assets/data/61f78720feb9133cc805da6be4ef47cb-CR0.data.json";